import _ from "lodash";
import { OperationStatus } from "../../../gateway/OperationStatus/OperationStatus";
import {
    AppSyncEventsSubscription,
    operationStatusAppSyncTraceEnabled
} from "../AppSyncEventsSubscription/AppSyncEventsSubscription";

export class OperationsStatus {
    constructor({ Scope, OperationStatusDomain, Insight } = {}) {
        this.OperationStatusDomain = OperationStatusDomain;
        this.Insight = Insight;
        this.operationsStatus = [];
        this.Scope = Scope;
        this.subscribedEvent = {};
        this.OperationStatusGateway = new OperationStatus();
        this.appSyncClient = null;
        this.subscriptionId = null;
        this.lastListFilter = null;
        this.listFilter = null;
        this._debounceTimer = null;
    }

    setAccountingId(accountingId) {
        this.accountingId = accountingId;
    }

    setCompanyId(companyId) {
        this.companyId = companyId;
    }

    buildChannelFromListFilter(listFilter) {
        if (listFilter?.accountingId) {
            return `/operations/${listFilter.accountingId}`;
        }
        const cfg = publicSettings?.aws?.operationStatusAppSync;
        const ns = cfg?.defaultNamespace || "default";
        const path = cfg?.defaultChannelPath || "/channel";
        const suffix = path.startsWith("/") ? path : `/${path}`;
        return `/${ns}${suffix}`;
    }

    observable(listFilter, onReceiveEvent) {
        this.lastListFilter = listFilter;
        void this._setupRealtime(listFilter, onReceiveEvent);
        this.subscribedEvent = {
            stop: () => this.stop()
        };
        return this.subscribedEvent;
    }

    async _setupRealtime(listFilter, onReceiveEvent) {
        this.stop();
        this.listFilter = listFilter;
        const pushList = async () => {
            const list = await this.OperationStatusGateway.listOperationAlerts(
                this.listFilter
            );
            const items = list?.items || list || [];
            const arr = Array.isArray(items) ? items : [];
            if (operationStatusAppSyncTraceEnabled()) {
                console.info("[AppSyncEvent]", "listOperationAlerts retorno", {
                    hasItemsProp: Boolean(list?.items),
                    count: arr.length,
                    keys:
                        list && typeof list === "object"
                            ? Object.keys(list)
                            : []
                });
            }
            const run = () => onReceiveEvent(arr);
            if (this.Scope?.$applyAsync) this.Scope.$applyAsync(run);
            else run();
        };
        await pushList();
        const cfg = publicSettings?.aws?.operationStatusAppSync;
        if (!cfg?.realtimeHost || !cfg?.httpHost) {
            return;
        }
        try {
            this.appSyncClient = new AppSyncEventsSubscription({
                httpHost: cfg.httpHost,
                realtimeHost: cfg.realtimeHost
            });
            await this.appSyncClient.connect();
            this.subscriptionId = `opst_${Date.now()}_${Math.random()
                .toString(36)
                .slice(2, 9)}`;
            const channel = this.buildChannelFromListFilter(this.listFilter);
            this.appSyncClient.subscribe(this.subscriptionId, channel, {
                onData: () => {
                    if (operationStatusAppSyncTraceEnabled()) {
                        console.info(
                            "[AppSyncEvent]",
                            "OperationsStatus: evento ws → nova listagem HTTP"
                        );
                    }
                    clearTimeout(this._debounceTimer);
                    this._debounceTimer = setTimeout(() => {
                        void pushList();
                    }, 300);
                }
            });
        } catch (e) {
            console.error("OperationsStatus AppSync", e);
        }
    }

    stop() {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = null;
        if (this.appSyncClient && this.subscriptionId) {
            this.appSyncClient.unsubscribe(this.subscriptionId);
        }
        if (this.appSyncClient) {
            this.appSyncClient.close();
        }
        this.appSyncClient = null;
        this.subscriptionId = null;
        return this.subscribedEvent;
    }

    startOperationsStatusObservable(callback) {
        this.operationsStatusObservable = this.observable(
            {
                accountingId: this.accountingId,
                companyId: this.companyId,
                operations: ["Insights.generator"]
            },
            (events) => {
                this.onReceiveOperationsStatusEvent(events, callback);
            }
        );
    }

    async onReceiveOperationsStatusEvent(events, callback) {
        if (!events.length) return;
        const event = _.last(events) || {};
        const removed = await this.OperationStatusDomain.removeOne(event._id);
        if (!removed) return false;
        const accountingId = this.accountingId;
        this.Insight.deleteMany({
            accountingId,
            companyId: this.companyId
        });
        await this.Insight.populate(
            { companyId: this.companyId },
            {},
            { accountingId }
        );
        if (callback) callback();
        this.operationsStatusObservable.stop();
    }
}
